<script>
  import YamInfoPanel from '@xhs/yam-info-panel'

  export default {
    name: 'PanelLayout',

    components: {
      YamInfoPanel,
    },

    props: {
      label: {
        type: String,
        default: '',
      },
    },
  }
</script>

<template>
  <yam-info-panel :data="{ title: label }">
    <slot />
  </yam-info-panel>
</template>
